import { render, staticRenderFns } from "./Dead.vue?vue&type=template&id=06f3c450&"
import script from "./Dead.vue?vue&type=script&lang=ts&"
export * from "./Dead.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports